import {TYPE_UPDATE_FORM_DATA} from "./types";

export function updateFormDataAction(exchangedData) {
	return {
		type: TYPE_UPDATE_FORM_DATA,
		exchangedData,
	};
}
